class exports.ChemicalsValidator

    constructor: (hot, chemicals) ->
        @hot = hot
        @chemicals = chemicals
        @is_valid = true
        @validation_messages = []

    validateName: (cell, callback) =>
        if cell.ignore
            return @markValid(callback)

        # make sure the name is set and not empty
        if (not cell.value?) or cell.value.trim() is ''
            return @markInvalid(callback, 'Chemical Name must be set.')

        # check for uniqueness
        chemical = @hot.getSourceDataAtRow(cell.row)
        for other_chemical in @chemicals
            # make sure we don't include the chemical we're validating
            if other_chemical is chemical
                continue
            if other_chemical.name is cell.value
                return @markInvalid(callback, 'Chemical Name must be unique.')

        return @markValid(callback)

    validateWindSpeed: (cell, callback) =>
        if cell.ignore or not cell.value? or cell.value is ''
            return @markValid(callback)

        # Don't allow that text trash up in here!
        if not ($.isNumeric(cell.value) and (Math.floor(cell.value) is cell.value))
            return @markInvalid(callback, 'Max Wind Speed must be numeric.')

        # make sure the wind speed is either not set, or between 0 and 99
        if parseInt(cell.value, 10) < 0 or parseInt(cell.value, 10) > 99
            return @markInvalid(callback, 'Max Wind Speed must be between 0 and 99 mph.')

        return @markValid(callback)

    validateModeOfAction: (cell, callback) =>
        if cell.ignore or not cell.value? or cell.value is ''
            return @markValid(callback)

        # make sure the MOA is valid. ignore if parent
        chemical = @hot.getSourceDataAtRow(cell.row)
        if not chemical.children?.length and String(cell.value) not in [
                '1',
                '1A',
                '1B',
                '2',
                '2B',
                '3',
                '4',
                '4A',
                '4D',
                '5',
                '6',
                '7',
                '7A',
                '8',
                '8B',
                '8F',
                '9',
                '10',
                '10A',
                '10B',
                '11',
                '11A',
                '12',
                '12C',
                '13',
                '14',
                '15',
                '16',
                '17',
                '18',
                '19',
                '20',
                '20A',
                '21',
                '22',
                '23',
                '24',
                '24A',
                '25',
                '26',
                '27',
                '28',
                '29',
                '33',
                '44',
                'M1',
                'M2',
                'M3',
                'M4',
                'M5',
                'P5',
                'UN'
            ]
                return @markInvalid(callback, 'Mode of Action must be valid.')

        return @markValid(callback)

    validateCategory: (cell, callback) =>
        if cell.ignore or not cell.value
            return @markValid(callback)

        if cell.value not in (['Fungicide', 'Herbicide', 'Insecticide', 'Growth Regulator', 'Fumigant', 'Defoliant'])
            return @markInvalid(callback, 'Category must be one of Fungicide, Herbicide, Insecticide, Growth Regulator, Fumigant, or Defoliant.')

        return @markValid(callback)

    markInvalid: (callback, message) =>
        if message not in @validation_messages
            @validation_messages.push(message)

        @is_valid = false
        callback(false)
        return false

    markValid: (callback) =>
        callback(true)
        return true
